import React from 'react'

const OtherIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M0 10C0 4.48148 4.48148 0 10 0C15.5185 0 20 4.48148 20 10C20 15.5185 15.5185 20 10 20C4.48148 20 0 15.5185 0 10ZM4.07422 10C4.07422 10.8149 4.74089 11.4815 5.5557 11.4815C6.37051 11.4815 7.03718 10.8149 7.03718 10C7.03718 9.18522 6.37051 8.51855 5.5557 8.51855C4.74089 8.51855 4.07422 9.18522 4.07422 10ZM10 11.4815C9.18522 11.4815 8.51855 10.8149 8.51855 10C8.51855 9.18522 9.18522 8.51855 10 8.51855C10.8149 8.51855 11.4815 9.18522 11.4815 10C11.4815 10.8149 10.8149 11.4815 10 11.4815ZM12.9629 10C12.9629 10.8149 13.6296 11.4815 14.4444 11.4815C15.2592 11.4815 15.9259 10.8149 15.9259 10C15.9259 9.18522 15.2592 8.51855 14.4444 8.51855C13.6296 8.51855 12.9629 9.18522 12.9629 10Z"
    fill="#9B9B9B"
  />
)

export default OtherIcon
